// Italiano — mirrors en.js key for key. it distinguishes one/other in CLDR.
const it = {
  // ===== shared =====
  'common.createPlan': 'Crea piano',
  'common.save': 'Salva',
  'common.cancel': 'Annulla',
  'common.delete': 'Elimina',
  'common.edit': 'Modifica',
  'common.retry': 'Riprova',
  'common.activate': 'Attiva',
  'common.deactivate': 'Disattiva',
  'common.enabled': 'Attivo',
  'common.disabled': 'Disattivo',
  'common.viewTerms': 'Vedi condizioni',
  'common.untitledPlan': 'Piano senza titolo',
  'common.savedToast': 'Salvato correttamente',

  // ===== nav / chrome =====
  'nav.home': 'Home',
  'nav.plans': 'Piani',
  'nav.settings': 'Impostazioni',

  'mismatch.title': 'Ambiente di distribuzione non corrispondente',
  'mismatch.body': 'Questa build del frontend chiama {apiBase}, ma viene servita da {hostname} (previsto: {expected}).',
  'mismatch.contact': 'Contatta l’assistenza tecnica — si tratta di un errore di configurazione della distribuzione, non di un problema con il tuo account.',

  'install.title': 'Impossibile connettersi a Shopify',
  'install.body': 'Verifica che il backend sia in esecuzione e che la sua SHOPIFY_API_KEY corrisponda al client_id dell’app in shopify.app.toml.',
  'install.retry': 'Riprova',

  'chrome.loadingBrand': 'Caricamento di FlexCover…',
  'error.title': 'Si è verificato un problema',
  'error.reload': 'Ricarica',

  'support.badge': 'Vista supporto',
  'support.shopUnknown': '(negozio sconosciuto)',
  'support.expired': 'Token scaduto — rigeneralo dalla console di supporto',
  'support.validUntil': 'Token valido fino alle {time}',
  'support.exit': 'Esci',

  // ===== Home =====
  'home.title': 'Benvenuto in FlexCover: Protection Plans 👋',
  'home.last30days': 'Ultimi 30 giorni',
  'home.loadingChart': 'Caricamento del grafico',
  'home.loadingOverview': 'Caricamento della panoramica',
  'home.statOrders': 'Ordini con piani',
  'home.statRevenue': 'Ricavo totale dei piani',
  'home.gettingStarted': 'Per iniziare',
  'home.allSet': 'Tutto pronto 🎉',
  'home.completed': '{done} di {total} completati',
  'home.step1.title': 'Crea il tuo primo piano',
  'home.step1.desc': 'Imposta prezzo, copertura e aspetto nel carrello della tua offerta di protezione.',
  'home.step2.title': 'Attiva il modulo dell’app',
  'home.step2.desc': 'Attiva il blocco FlexCover: Protection Plans così che il widget appaia nel carrello.',
  'home.step2.enable': 'Attiva modulo app',
  'home.step2.check': 'Verifica stato',
  'home.step3.title': 'Ottieni il tuo primo ordine protetto',
  'home.step3.desc': 'Con il widget attivo, i clienti aggiungono un piano nel carrello — i totali compaiono nelle schede qui sopra.',
  'home.appEmbed': 'Modulo app',
  'home.checkingEmbed': 'Verifica dello stato del modulo app',
  'home.embedEnabledBody': 'Il widget di protezione è attivo sulla tua vetrina.',
  'home.embedTheme': '(tema: {theme})',
  'home.embedDisabledBody': 'L’app non è attualmente attiva sulla tua vetrina.',
  'home.embedUnknown': 'Sconosciuto',
  'home.embedUnknownBody': 'Lo stato della vetrina sarà disponibile una volta collegata l’app a un negozio.',
  'home.embedUnknownReason': 'Impossibile leggere il tema online in questo momento.',
  'home.enableEmbedHint': 'Nell’admin di Shopify, vai su Online Store → Temi → Personalizza → Moduli app, poi attiva FlexCover: Protection Plans.',
  'home.learnMorePrefix': 'Scopri di più su ',
  'home.learnMoreLink': 'come usare i piani di protezione',

  // ===== Plans list =====
  'plans.title': 'Piani',
  'plans.loading': 'Caricamento dei piani',
  'plans.errorTitle': 'Impossibile caricare i piani',
  'plans.empty.heading': 'Crea il tuo primo piano di protezione',
  'plans.empty.body': 'Offri protezione spedizione, garanzie estese, assicurazione reso e copertura personalizzata — tutto con i prezzi che decidi tu.',
  'plans.loadDemo': 'Carica piani demo',
  'plans.demoLoaded': 'Piani demo caricati',
  'plans.demoFailed': 'Caricamento dei piani demo non riuscito: {message}',
  'plans.filterPlaceholder': 'Filtra piani',
  'plans.addFilter': 'Aggiungi filtro',
  'plans.statusHeading': 'Stato',
  'plans.typeHeading': 'Tipo di protezione',
  'plans.statusActive': 'Attivo',
  'plans.statusInactive': 'Inattivo',
  'plans.showing_one': '{count} piano visualizzato',
  'plans.showing_other': '{count} piani visualizzati',
  'plans.sortBy': 'Ordina per',
  'plans.selectAll': 'Seleziona tutti i piani',
  'plans.selectedCount': '{count} selezionati',
  'plans.bulkDeleted_one': '{count} piano eliminato',
  'plans.bulkDeleted_other': '{count} piani eliminati',
  'plans.bulkActivated_one': '{count} piano attivato',
  'plans.bulkActivated_other': '{count} piani attivati',
  'plans.bulkDeactivated_one': '{count} piano disattivato',
  'plans.bulkDeactivated_other': '{count} piani disattivati',
  'plans.deleteBulkFailed': 'Eliminazione non riuscita: {message}',
  'plans.updateBulkFailed': 'Aggiornamento non riuscito: {message}',
  'plans.activated': 'Piano attivato',
  'plans.deactivated': 'Piano disattivato',
  'plans.updateFailed': 'Aggiornamento del piano non riuscito: {message}',
  'plans.deleted': 'Piano eliminato',
  'plans.deleteFailed': 'Eliminazione del piano non riuscita: {message}',
  'plans.actionsFor': 'Azioni per {name}',
  'plans.activatePlan': 'Attiva {name}',
  'plans.deactivatePlan': 'Disattiva {name}',
  'plans.onlineStore': 'Negozio online',
  'plans.optional': 'Opzionale',
  'plans.automatic': 'Automatico',
  'plans.noMatch': 'Nessun piano corrisponde alla ricerca o ai filtri.',
  'plans.deleteTitle': 'Eliminare il piano di protezione?',
  'plans.deleteBody': 'verrà rimosso immediatamente dal tuo negozio. I clienti non vedranno più questa opzione di protezione.',
  'plans.helpPrefix': 'Serve aiuto? ',
  'plans.helpLink': 'Scrivici',
  'plans.helpSuffix': ' o consulta la documentazione e i tutorial dell’app.',

  'sort.date': 'Data (più recenti prima)',
  'sort.name': 'Nome (A–Z)',
  'sort.sortOrder': 'Ordine nel carrello',
  'sort.price': 'Prezzo (crescente)',

  'planType.shipping_protection': 'Protezione spedizione',
  'planType.warranty': 'Garanzia',
  'planType.return_insurance': 'Assicurazione reso',
  'planType.custom': 'Protezione personalizzata',
  'planTypeShort.shipping_protection': 'Spedizione',
  'planTypeShort.warranty': 'Garanzia',
  'planTypeShort.return_insurance': 'Reso',
  'planTypeShort.custom': 'Personalizzata',
  'priceType.fixed': 'Importo fisso',
  'priceType.percentage': 'Percentuale dell’ordine',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Piano di protezione',
  'plan.loading': 'Caricamento del piano',
  'plan.notFound.heading': 'Piano non trovato',
  'plan.notFound.body': 'Questo piano di protezione potrebbe essere stato eliminato.',
  'plan.backToPlans': 'Torna ai piani',
  'plan.newTitle': 'Nuovo piano di protezione',
  'plan.newSubtitle': 'Configura prezzi e aspetto nel carrello, poi crea il piano',
  'plan.subtitle': 'Le modifiche si applicano al tuo negozio dopo il salvataggio',
  'plan.statusTitle': 'Stato del piano',
  'plan.saveFailed': 'Salvataggio del piano non riuscito: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Tipo di protezione',
  'form.section.basics': 'Informazioni di base del piano',
  'form.section.pricing': 'Prezzi — {type}',
  'form.pricingFallback': 'Protezione',
  'form.section.appearance': 'Aspetto',
  'form.section.fulfillment': 'Evasione',

  'form.type.shipping_protection': 'Protezione spedizione',
  'form.type.shipping_protection.help': 'Protegge l’ordine del cliente da perdita, danni o furti durante la spedizione.',
  'form.type.warranty': 'Garanzia',
  'form.type.warranty.help': 'Copre difetti di fabbricazione e usura normale per un periodo determinato.',
  'form.type.return_insurance': 'Assicurazione reso',
  'form.type.return_insurance.help': 'Consente ai clienti di restituire articoli entro un termine per un rimborso completo.',
  'form.type.custom': 'Protezione personalizzata',
  'form.type.custom.help': 'Il tuo messaggio di copertura personalizzato.',

  'form.defaults.untitledPlan': 'Piano senza titolo',
  'form.defaults.viewTerms': 'Vedi condizioni',
  'form.defaults.shipping_protection.displayName': 'Protezione spedizione',
  'form.defaults.shipping_protection.description': 'Protegge il tuo ordine da perdita, danni e furti durante la spedizione.',
  'form.defaults.warranty.displayName': 'Garanzia estesa',
  'form.defaults.warranty.description': 'Copre difetti di fabbricazione e usura normale per 2 anni.',
  'form.defaults.return_insurance.displayName': 'Assicurazione reso',
  'form.defaults.return_insurance.description': 'Restituisci qualsiasi articolo entro 14 giorni con rimborso completo.',
  'form.defaults.custom.displayName': 'Piano di protezione',
  'form.defaults.custom.description': 'Aggiungi protezione al tuo ordine.',

  'form.lang.select': 'Seleziona lingua',
  'form.lang.default': '{name} (predefinito)',
  'form.translated': '(tradotto)',

  'form.field.planName.label': 'Nome del piano (interno)',
  'form.field.planName.help': 'Solo per tuo riferimento — i clienti non lo vedono mai',
  'form.field.nameRequired': 'Il nome interno è obbligatorio',
  'form.field.displayName.label': 'Nome visualizzato',
  'form.field.displayNameRequired': 'Il nome visualizzato è obbligatorio',
  'form.field.displayName.placeholder': 'Nome visualizzato',
  'form.field.displayName.help': 'Mostrato ai clienti nel carrello e al checkout',
  'form.field.displayName.helpPreset': 'Mostrato ai clienti che navigano in {lang}',
  'form.field.displayName.helpPresetFallback': 'Mostrato ai clienti che navigano in {lang} — i campi vuoti ricadono sul {primary}',
  'form.field.description.label': 'Descrizione',
  'form.field.description.placeholder': 'Descrizione',
  'form.field.description.help': 'Breve descrizione per i clienti mostrata sotto il nome del piano',
  'form.field.disabledDescription.label': 'Descrizione se non selezionato',
  'form.field.disabledDescription.placeholder': 'Facoltativo — mostrato quando il piano non è selezionato',
  'form.field.disabledDescription.help': 'Mostrato quando la casella del piano è deselezionata (ricade sulla descrizione sopra se vuoto)',
  'form.field.footer.label': 'Piè di pagina',
  'form.field.footerText.label': 'Testo del piè di pagina',
  'form.field.footerLink.label': 'Link del piè di pagina',
  'form.field.footerLink.help': 'Destinazione del link del testo del piè di pagina',

  'form.price.type.label': 'Tipo di prezzo',
  'form.price.fixed': 'Importo ($)',
  'form.price.percentage': 'Percentuale (%)',
  'form.price.advanced': 'Impostazione avanzata',
  'form.price.pctSummary': '{pct}% dell’importo dell’ordine, da ${min} con incrementi di ${inc} fino a ${max} — {count} varianti sul prodotto del piano',
  'form.price.tiersSummary_one': 'Il prodotto del piano riceve 1 variante a {base} più {count} variante a intervalli per le regole di valore del carrello',
  'form.price.tiersSummary_other': 'Il prodotto del piano riceve 1 variante a {base} più {count} varianti a intervalli per le regole di valore del carrello',

  'form.validation.priceRequired': 'Inserisci un valore maggiore di 0',
  'form.validation.priceMax100': 'La percentuale non può superare 100',
  'form.validation.warrantyYears': 'Inserisci una durata tra 1 e 5 anni',
  'form.validation.returnDays': 'Inserisci un termine tra 7 e 365 giorni',
  'form.validation.maxGreaterThanMin': 'Il massimo deve essere maggiore del minimo',
  'form.validation.variantIdNumeric': 'L’ID variante deve essere numerico (l’ID della variante nascosta del piano)',

  'form.icon.label': 'Icona',
  'form.icon.useEmoji': 'Usa {emoji} come icona del piano',
  'form.icon.removeCustom': 'Rimuovi l’icona personalizzata e usa l’icona a scudo',
  'form.icon.upload': 'Carica un’immagine icona personalizzata',
  'form.icon.uploadButton': 'Carica',
  'form.icon.uploading': 'Caricamento dell’icona',
  'form.icon.uploadHelp': 'Carica la tua icona — PNG, JPEG, GIF o WebP, fino a 5 MB.',
  'form.icon.error.notImage': 'Scegli un file immagine (PNG, JPEG, GIF o WebP).',
  'form.icon.error.tooLarge': 'L’immagine deve essere di 5 MB o meno.',

  'form.fulfillment.intro': 'Scegli quando il prodotto di protezione viene contrassegnato come evaso.',
  'form.fulfillment.manually': 'Evasione manuale',
  'form.fulfillment.first_item': 'Contrassegna come evaso quando il primo articolo dell’ordine viene evaso',
  'form.fulfillment.all_items': 'Contrassegna come evaso quando tutti gli altri articoli dell’ordine vengono evasi',
  'form.fulfillment.immediately': 'Contrassegna come evaso subito dopo la creazione dell’ordine',

  'form.adv.title': 'Impostazione avanzata',
  'form.adv.minPrice': 'Prezzo minimo',
  'form.adv.minPriceHelp': 'Il prezzo della prima variante — la tariffa minima applicata dal piano',
  'form.adv.increment': 'Importo dell’incremento',
  'form.adv.incrementHelp': 'Graduale di prezzo tra le varianti generate',
  'form.adv.maxPriceLabel': 'Prezzo massimo: ',
  'form.adv.explanation': 'Il prodotto del piano viene generato con {buckets} varianti: il prezzo minimo {min} occupa una variante e le restanti {rest} varianti salgono a passi di {inc}, fino a un prezzo massimo di {max}. Al checkout il cliente paga la prima variante con prezzo pari o superiore al {pct}% del subtotale del carrello — un carrello di $100 al 2% punta a $2.00, quindi si applica la variante da $3.01. ',
  'form.learnMore': 'Scopri di più',

  'form.tiers.title': 'Imposta il prezzo per valore del carrello',
  'form.tiers.minCol': 'Valore minimo del carrello',
  'form.tiers.maxCol': 'Valore massimo del carrello',
  'form.tiers.priceCol': 'Prezzo della protezione',
  'form.tiers.addTier': 'Aggiungi nuova fascia',
  'form.tiers.deleteTier': 'Elimina fascia {index}',
  'form.tiers.explanation': 'Ogni regola richiede un minimo, un massimo e un prezzo (le regole possono sovrapporsi — si applica la prima regola corrispondente). Ogni regola diventa una variante propria sul prodotto del piano. Se il totale del carrello non corrisponde a nessuna regola, si applica il prezzo fisso dell’impostazione principale. ',
  'form.tiers.error.minRequired': 'Il valore minimo del carrello è obbligatorio',
  'form.tiers.error.maxRequired': 'Il valore massimo del carrello è obbligatorio',
  'form.tiers.error.priceRequired': 'Il prezzo della protezione è obbligatorio',
  'form.tiers.error.pricePositive': 'Il prezzo deve essere maggiore di 0',
  'form.tiers.error.minMax': 'Il minimo deve essere minore o uguale al massimo',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Modifiche non salvate',
  'savebar.discard': 'Ignora',
  'savebar.saving': 'Salvataggio…',

  // ===== Preview panel =====
  'preview.title': 'Anteprima',
  'preview.simulatedSubtotal': 'Subtotale simulato del carrello',
  'preview.cart': 'Carrello',
  'preview.product': 'PRODOTTO',
  'preview.total': 'TOTALE',
  'preview.subtotal': 'Subtotale',
  'preview.checkout': 'Vai al checkout',
  'preview.noPlans': 'Ancora nessun piano attivo — i clienti non vedranno questo widget.',
  'preview.autoAdded': 'Aggiunto automaticamente',
  'preview.unsaved': 'Non salvato',

  // ===== Settings page =====
  'settings.title': 'Impostazioni',
  'settings.language.title': 'Preferenza lingua',
  'settings.language.help': 'Quando visiti FlexCover, questa è la lingua mostrata a te. La lingua del tuo negozio non è influenzata.',
  'settings.language.label': 'Lingua',
  'settings.language.updated': 'Lingua aggiornata',
  'settings.language.saveFailed': 'Salvataggio della preferenza lingua non riuscito: {message}'
};

export default it;
